import FormContainer from "@client/content/controls/Form/container";
import { getRootContainerProps } from "@client/content/lib/helper";
import { type ModuleApiInfo } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { type FormFieldInfo, type FormHandles } from "@client/controls/Form/component";
import Checkbox from "@client/controls/Inputs/Checkbox/component";
import { AutoCompleteLazy } from "@client/controls/Inputs/Select/AutoComplete/component";
import withIsVisibleHOC, { type WithIsVisibleHOCProps } from "@client/hocs/withIsVisible";
import { useI18n } from "@common/hooks/i18n";
import getOptions from "@common/lib/options";
import { identity } from "lodash";
import * as React from "react";
import { withOnSubmit } from "../../hooks";

export type MapProps = WithIsVisibleHOCProps & RootContainerProps & { userId?: number; apiInfo: ModuleApiInfo };

export interface ActionProps {}

export type Props = ActionProps & MapProps;

export default withIsVisibleHOC((props: Props) => {
  const i18n = useI18n();

  const options = React.useMemo(() => getOptions(i18n), [i18n]);

  const [showFields, setShowFields] = React.useState<boolean>(false);
  const ref = withOnSubmit<FormHandles>(identity);

  const fields = React.useMemo(
    (): FormFieldInfo[] => [
      {
        name: "orderForUserId",
        label: i18n.user,
        isRequired: true,
        Component: AutoCompleteLazy,
        componentOpts: {
          fetchOptions: (x) =>
            // TODO: security
            options.getOptionsPage("user", "genealogies", {
              ...x,
              userId: props.userId,
              isMaster: true
            })
        },
        qa: "User"
      }
    ],
    []
  );

  return (
    <div className="network_information">
      <h4>{i18n.networkInformation}</h4>

      <Checkbox label={i18n.OrderForDownline} onChange={(x) => setShowFields(x!)} value={showFields} />

      {showFields && <FormContainer {...getRootContainerProps(props)} ref={ref} fields={fields} validateOn="change" />}
    </div>
  );
});
